import { range } from "lodash";

const corp = { treasury: 0, savings: 0, checking: 562355 };
const intl = { treasury: 0, savings: 0, checking: 45154 };
const patagonia = { treasury: 0, checking: 0, checkingsUsd: 0 };
const balanz = { ars: 15777, usd: 0 };
const galicia = { treasury: 0, checking: 233153 };
const credicoop = { treasury: 14299900, checking: 354347 };

const fx = 1500;

const ars_balance =
  patagonia.treasury + patagonia.checking + galicia.treasury + galicia.checking + credicoop.treasury + credicoop.checking + balanz.ars;
const usd_balance =
  patagonia.checkingsUsd + intl.checking + intl.savings + intl.treasury + corp.checking + corp.savings + corp.treasury + balanz.usd;
export const bank_balance = ars_balance / fx + usd_balance;

const onTop = (salary) => salary + 67;
const argentina = (relDep, monotributo, swissMedical) => (relDep * 1.43 + monotributo + swissMedical) / fx;
const conIva = (value) => value / 1.21 / fx;
const sinIva = (value) => value / fx;

export const outcomes = {
  Outcomes: {
    Directos: {
      SOP: {
        "Ariel Gonzalez": onTop(4000) /* On Top */,
        "Eduardo Vila": argentina(542489, 4743733, 220000),
        "Lautaro Russo": argentina(539584, 1875546, 0),
        "Matias Monge": argentina(3226383, 0, 0),
      },
      "Staff Augmentation": { "José Luis Passardi": argentina(0, 4800 * fx, 0) },
      Desarrollo: {
        Test: { "Vanessa Quintero": onTop(3000) },
        POs: { "Luciano Novelli": onTop(6000), "Paola Zambudio": onTop(4000) },
        UX: { "Axel Collante": onTop(4500), "Camila Reberendo": onTop(3750) },
        Arq: { "Federico Sanchez": onTop(5500), "Tobias Levy": onTop(4000) },
        "Value Streams": {
          "The Brain": {
            "Align Works": {
              "Flavio Alfaro": { money: onTop(6000), people: 1 },
              "Marco Peñafort": { money: onTop(3500), people: 1 },
              "Nicolas Taccari": { money: onTop(4000), people: 1 },
            },
            "Re Brain": {
              "Marcelo Batto": { money: onTop(6000), people: 1 },
              "Mauricio Lucero": { money: onTop(4500), people: 1 },
              "Franco Sbriglio": { money: onTop(3500), people: 1 },
              "Sebastian Fernandez": { money: onTop(5100), people: 1 },
              "Antonela Néspoli": { money: onTop(4500), people: 1 },
              "Juan Manuel Chacon": { money: onTop(5000), people: 1 },
            },
          },
          MDA: { "Ariel Zeballes": { money: onTop(5500), people: 1 } },
          China: {
            "Javier Escudero": { money: onTop(6000), people: 1 },
            "Matias Carretero": { money: onTop(4000), people: 1 },
            "Damián Nutz": { money: onTop(4200), people: 1 },
          },
          SFDM: {
            "Juan Cruz Arancibia": { money: onTop(4500), people: 1 },
          },
        },
        "R & D": { "Gabriel Etcheberry": onTop(4000) },
      },
    },
    Indirectos: {
      "Licencias/Infra": {
        Argentina: {
          DropBox: 12,
          Wasabi: 9,
          Atlassian: { Normal: 1057, Tuqui: 135 },
          npm: 77,
          github: 10,
          figma: 40,
          docker: 11,
          "Amazon AWS": { S1: 6, S2: 273, S3: 36 },
          "AI Varias": 1500,
          "Google Suite": 243,
          Loom: 60,
        },
        USA: {
          github: 80,
          Kamatera: 500 /* 420 */,
          "Biblioteca de Libros": 16,
          Sonarcloud: 86,
        },
      },
      Directores: 6000 * 3,
      Administración: { Xime: argentina(364000, 2100000, 0) + onTop(500), Vicky: 1200 },
      "Recursos Humanos": { "Laura Zarate": onTop(2500) + 130000 / fx /*Swiss Medical */ },
      Servicios: {
        Argentina: {
          Carlos: conIva(484000),
          iPlan: conIva(105000),
          "Telecom/Personal": conIva(400000),
          Detrano: conIva(57000),
          Nalu: conIva(76000),
          CESSI: sinIva(84700),
          Ingles: [
            { month: "202503", value: conIva(300000) },
            { from: "202603", to: "202612", value: conIva(1500000) },
          ],
        },
        USA: {
          Oficina: 652,
          Lazo: 500,
          Quickbooks: 121,
          Moringo: 9000 / 12,
        },
        Ventas: {
          "Ivan Salgado": onTop(900),
        },
      },
      Others: 1000,
    },
    Inversión: {
      "Fer Perla": 2000,
      Lala: 3900,
      Otros: 1000,
    },
  },
};

const mandatoryMonts = [
  { id: "202608", name: "Aug/2026" },
  { id: "202609", name: "Sep/2026" },
  { id: "202610", name: "Oct/2026" },
  { id: "202611", name: "Nov/2026" },
  { id: "202612", name: "Dec/2026" },
  { id: "202701", name: "Jan/2027" },
  { id: "202702", name: "Feb/2027" },
  { id: "202703", name: "Mar/2027" },
];

const monthsIndex = Object.fromEntries(Object.entries(mandatoryMonts.map((x) => x.id)).map((x) => [x[1], x[0]]));
const months = [{ id: null, name: "-" }, ...mandatoryMonts];

const velocities = [20, 26, 50, 60, 70, 80, 90, 96, 100, 110, 120, 130, 134, 140, 150, 160, 170, 180, 190, 200].map((value) => ({
  id: value,
  name: `${value} SP`,
}));
const teamSizes = range(8, 15).map((value) => ({ id: value, name: `${value}p` }));
const bonusRatios = [0, 0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2].map((value) => ({ id: value, name: `${value}x` }));

const difInMonths = (start, end) => monthsIndex[end] - monthsIndex[start] + 1;

export const baseScenarios = {
  Bonus: {
    Bouns: {
      "DEV (50%)": {
        isSelected: true,
        options: [{ id: "bonus_dev_month", name: "Bonus Payment Dev", default: "202608", options: mandatoryMonts }],
        path: ["Outcomes", "Bonus", "DEV"],
        value: (options, variables) => [
          {
            from: options[0],
            to: options[0],
            value: 39025,
          },
        ],
      },
      "ARQ/ADM/People": {
        isSelected: true,
        options: [
          { name: "From", default: "202609", options: mandatoryMonts },
          { name: "To", default: "202609", options: mandatoryMonts },
        ],
        path: ["Outcomes", "Bonus", "ARQ/ADM/People"],
        value: (options, variables) => [
          {
            from: options[0],
            to: options[1],
            value: (5500 + 4000 + 2500 + 750) / difInMonths(options[0], options[1]),
          },
        ],
      },
    },
  },
  Viajes: {
    China: {
      isSelected: true,
      path: ["Outcomes", "Viajes", "China"],
      value: (options) => [{ month: "202609", value: 60 + 1544 + 144 + 1200 }],
    },
    Stellantis: {
      isSelected: true,
      path: ["Outcomes", "Viajes", "Stellantis"],
      options: [{ name: "Mes", default: "202610", options: mandatoryMonts }],
      value: (options) => [{ month: options[0], value: 4000 }],
    },
  },
  "Potenciales Proyectos": {
    "China - Phase II": {
      isSelected: false,
      options: [
        { default: "202606", options: mandatoryMonts },
        { default: "202612", options: mandatoryMonts },
      ],
      path: ["Incomes", "Proyectos", "China", "Phase II"],
      value: (options, variables) => [
        { from: options[0], to: options[1], value: 250000 / (monthsIndex[options[1]] - monthsIndex[options[0]] + 1) },
      ],
      people: (options, variables) => [
        { from: options[0], to: options[1], value: 18 / (monthsIndex[options[1]] - monthsIndex[options[0]] + 1) },
      ],
    },
    "Migración Servidores": {
      isSelected: false,
      path: ["Incomes", "Proyectos", "Argentina", "Migración Servidores"],
      options: [
        { default: "202606", options: mandatoryMonts },
        { default: "202612", options: mandatoryMonts },
      ],
      value: (options, variables) => [
        { from: options[0], to: options[1], value: 50000 / (monthsIndex[options[1]] - monthsIndex[options[0]] + 1) },
      ],
      people: (options, variables) => [],
    },
    Proplan: {
      isSelected: false,
      path: ["Incomes", "Proyectos", "Argentina", "Asofarma"],
      options: [
        { default: "202605", options: mandatoryMonts },
        { default: "202612", options: mandatoryMonts },
      ],
      value: (options, variables) => [
        { from: options[0], to: options[1], value: 260000 / (monthsIndex[options[1]] - monthsIndex[options[0]] + 1) },
      ],
      people: (options, variables) => [
        { from: options[0], to: options[1], value: 26 / (monthsIndex[options[1]] - monthsIndex[options[0]] + 1) },
      ],
    },
  },
  Renovaciones: {
    "Merrill Lynch": {
      isSelected: true,
      path: ["Incomes", "Staff Augmentation", "Merrill Lynch"],
      value: [{ from: "202705", value: 8000 }],
    },
  },
  "Recursos Humanos": {
    _variables: [
      { id: "average_leader", name: "Average Leader", default: 6000, options: [5000, 5500, 6000, 6500, 7000, 7500, 8000] },
      { id: "average_developer", name: "Average Developer", default: 4000, options: [3000, 3500, 4000, 4500, 5000, 5500, 6000] },
    ],
    Hirings: {
      1: {
        isSelected: false,
        path: ["Outcomes", "Directos", "Desarrollo", " Changes", "Hirings"],
        options: [
          { default: "202603", options: mandatoryMonts },
          { default: 0, options: range(0, 3).map((x) => ({ id: x, name: `${x} Leader` })) },
          { default: 0, options: range(0, 11).map((x) => ({ id: x, name: `${x} Developer` })) },
        ],
        value: (options, variables) => [
          { from: options[0], value: options[1] * onTop(variables.average_leader) + options[2] * onTop(variables.average_developer) },
        ],
        people: (options, variables) => [
          { month: options[0], value: -options[1] - options[2] },
          { from: options[0], value: options[1] + options[2] },
        ],
      },
      2: {
        isSelected: false,
        path: ["Outcomes", "Directos", "Desarrollo", " Changes", "Hirings"],
        options: [
          { default: "202603", options: mandatoryMonts },
          { default: 0, options: range(0, 3).map((x) => ({ id: x, name: `${x} Leader` })) },
          { default: 0, options: range(0, 11).map((x) => ({ id: x, name: `${x} Developer` })) },
        ],
        value: (options, variables) => [
          { from: options[0], value: options[1] * onTop(variables.average_leader) + options[2] * onTop(variables.average_developer) },
        ],
        people: (options, variables) => [
          { month: options[0], value: -options[1] - options[2] },
          { from: options[0], value: options[1] + options[2] },
        ],
      },
      3: {
        isSelected: false,
        path: ["Outcomes", "Directos", "Desarrollo", " Changes", "Hirings"],
        options: [
          { default: "202603", options: mandatoryMonts },
          { default: 0, options: range(0, 3).map((x) => ({ id: x, name: `${x} Leader` })) },
          { default: 0, options: range(0, 11).map((x) => ({ id: x, name: `${x} Developer` })) },
        ],
        value: (options, variables) => [
          { from: options[0], value: options[1] * onTop(variables.average_leader) + options[2] * onTop(variables.average_developer) },
        ],
        people: (options, variables) => [
          { month: options[0], value: -options[1] - options[2] },
          { from: options[0], value: options[1] + options[2] },
        ],
      },
      4: {
        isSelected: false,
        path: ["Outcomes", "Directos", "Desarrollo", " Changes", "Hirings"],
        options: [
          { default: "202603", options: mandatoryMonts },
          { default: 0, options: range(0, 3).map((x) => ({ id: x, name: `${x} Leader` })) },
          { default: 0, options: range(0, 11).map((x) => ({ id: x, name: `${x} Developer` })) },
        ],
        value: (options, variables) => [
          { from: options[0], value: options[1] * onTop(variables.average_leader) + options[2] * onTop(variables.average_developer) },
        ],
        people: (options, variables) => [
          { month: options[0], value: -options[1] - options[2] },
          { from: options[0], value: options[1] + options[2] },
        ],
      },
      5: {
        isSelected: false,
        path: ["Outcomes", "Directos", "Desarrollo", " Changes", "Hirings"],
        options: [
          { default: "202603", options: mandatoryMonts },
          { default: 0, options: range(0, 3).map((x) => ({ id: x, name: `${x} Leader` })) },
          { default: 0, options: range(0, 11).map((x) => ({ id: x, name: `${x} Developer` })) },
        ],
        value: (options, variables) => [
          { from: options[0], value: options[1] * onTop(variables.average_leader) + options[2] * onTop(variables.average_developer) },
        ],
        people: (options, variables) => [
          { month: options[0], value: -options[1] - options[2] },
          { from: options[0], value: options[1] + options[2] },
        ],
      },
    },
    Desvinculaciones: {
      1: {
        isSelected: false,
        path: ["Outcomes", "Directos", "Desarrollo", " Changes", "Desvinculaciones"],
        options: [
          { default: "202607", options: mandatoryMonts },
          { default: 1, options: range(0, 3).map((x) => ({ id: x, name: `${x} Leader` })) },
          { default: 3, options: range(0, 11).map((x) => ({ id: x, name: `${x} Developer` })) },
        ],
        value: (options, variables) => [
          { from: options[0], value: options[1] * -onTop(variables.average_leader) + options[2] * -onTop(variables.average_developer) },
          {
            month: options[0],
            value: 2 * (options[1] * onTop(variables.average_leader) + options[2] * onTop(variables.average_developer)),
          },
        ],
        people: (options, variables) => [{ from: options[0], value: -options[1] - options[2] }],
      },
      2: {
        isSelected: false,
        path: ["Outcomes", "Directos", "Desarrollo", " Changes", "Desvinculaciones"],
        options: [
          { default: "202609", options: mandatoryMonts },
          { default: 0, options: range(0, 3).map((x) => ({ id: x, name: `${x} Leader` })) },
          { default: 1, options: range(0, 11).map((x) => ({ id: x, name: `${x} Developer` })) },
        ],
        value: (options, variables) => [
          { from: options[0], value: options[1] * -onTop(variables.average_leader) + options[2] * -onTop(variables.average_developer) },
          {
            month: options[0],
            value: 2 * (options[1] * onTop(variables.average_leader) + options[2] * onTop(variables.average_developer)),
          },
        ],
        people: (options, variables) => [{ from: options[0], value: -options[1] - options[2] }],
      },
      3: {
        isSelected: false,
        path: ["Outcomes", "Directos", "Desarrollo", " Changes", "Desvinculaciones"],
        options: [
          { default: "202603", options: mandatoryMonts },
          { default: 0, options: range(0, 3).map((x) => ({ id: x, name: `${x} Leader` })) },
          { default: 0, options: range(0, 11).map((x) => ({ id: x, name: `${x} Developer` })) },
        ],
        value: (options, variables) => [
          { from: options[0], value: options[1] * -onTop(variables.average_leader) + options[2] * -onTop(variables.average_developer) },
          {
            month: options[0],
            value: 2 * (options[1] * onTop(variables.average_leader) + options[2] * onTop(variables.average_developer)),
          },
        ],
        people: (options, variables) => [{ from: options[0], value: -options[1] - options[2] }],
      },
      "Plantilla Actual": {
        "Ariel Zeballes": {
          path: ["Outcomes", "Directos", "Desarrollo", "Value Streams", "MDA", "Ariel Zeballes"],
          options: [{ default: "202605", options: mandatoryMonts }],
          value: (options, variables) => [
            { from: options[0], value: onTop(-5500) },
            { month: options[0], value: onTop(5500 * 2) },
          ],
          people: (options, variables) => [
            { month: options[0], value: 1 },
            { from: options[0], value: -1 },
          ],
        },
        "Cecilia Cuchietti": {
          path: ["Outcomes", "Directos", "Desarrollo", "Value Streams", "The Brain", "Re Brain", "Cecilia Cuchietti"],
          options: [{ default: "202605", options: mandatoryMonts }],
          value: (options, variables) => [
            { from: options[0], value: onTop(-4000) },
            { month: options[0], value: onTop(4000 * 2) },
          ],
          people: (options, variables) => [
            { month: options[0], value: 1 },
            { from: options[0], value: -1 },
          ],
        },
        "Franco Sbriglio": {
          path: ["Outcomes", "Directos", "Desarrollo", "Value Streams", "The Brain", "Re Brain", "Franco Sbriglio"],
          options: [{ default: "202605", options: mandatoryMonts }],
          value: (options, variables) => [
            { from: options[0], value: onTop(-3500) },
            { month: options[0], value: onTop(3500 * 2) },
          ],
          people: (options, variables) => [
            { month: options[0], value: 1 },
            { from: options[0], value: -1 },
          ],
        },
        "Sebastian Fernandez": {
          path: ["Outcomes", "Directos", "Desarrollo", "Value Streams", "The Brain", "Re Brain", "Sebastian Fernandez"],
          options: [{ default: "202605", options: mandatoryMonts }],
          value: (options, variables) => [
            { from: options[0], value: onTop(-5100) },
            { month: options[0], value: onTop(5100 * 2) },
          ],
          people: (options, variables) => [
            { month: options[0], value: 1 },
            { from: options[0], value: -1 },
          ],
        },
        "Marco Peñafort": {
          path: ["Outcomes", "Directos", "Desarrollo", "Value Streams", "The Brain", "Align Works", "Marco Peñafort"],
          options: [{ default: "202605", options: mandatoryMonts }],
          value: (options, variables) => [
            { from: options[0], value: onTop(-3500) },
            { month: options[0], value: onTop(3500 * 2) },
          ],
          people: (options, variables) => [
            { month: options[0], value: 1 },
            { from: options[0], value: -1 },
          ],
        },
        "Juan Manuel Chacon": {
          path: ["Outcomes", "Directos", "Desarrollo", "Value Streams", "The Brain", "Re Brain", "Juan Manuel Chacon"],
          options: [{ default: "202605", options: mandatoryMonts }],
          value: (options, variables) => [
            { from: options[0], value: onTop(-5000) },
            { month: options[0], value: onTop(5000 * 2) },
          ],
          people: (options, variables) => [
            { month: options[0], value: 1 },
            { from: options[0], value: -1 },
          ],
        },
        "Antonela Néspoli": {
          path: ["Outcomes", "Directos", "Desarrollo", "Value Streams", "The Brain", "Re Brain", "Antonela Néspoli"],
          options: [{ default: "202605", options: mandatoryMonts }],
          value: (options, variables) => [
            { from: options[0], value: onTop(-4500) },
            { month: options[0], value: onTop(4500 * 2) },
          ],
          people: (options, variables) => [
            { month: options[0], value: 1 },
            { from: options[0], value: -1 },
          ],
        },
      },
    },
  },
};
